import { TAG_STYLE } from 'transfix-ui/components/Tag'
import { ICarrierApplicationStates } from 'types/graphqlTypes'

export const STATUS_TAG_LABELS: Record<ICarrierApplicationStates, string> = {
  [ICarrierApplicationStates.activated]: 'Activated',
  [ICarrierApplicationStates.application_submitted]: 'Pending Approval',
  [ICarrierApplicationStates.cancelled]: 'Not Active',
  [ICarrierApplicationStates.conditional]: 'Not Active',
  [ICarrierApplicationStates.do_not_use]: 'Not Active',
  [ICarrierApplicationStates.expired_insurance]: 'Expired Insurance',
  [ICarrierApplicationStates.in_review]: 'Pending Approval',
  [ICarrierApplicationStates.new]: 'New',
  [ICarrierApplicationStates.other]: 'Not Active',
  [ICarrierApplicationStates.out_of_service]: 'Not Active',
  [ICarrierApplicationStates.pending]: 'Pending Approval',
  [ICarrierApplicationStates.probation]: 'Not Active',
}

export const NEW_STATUS_TAG_LABELS: Record<ICarrierApplicationStates, string> = {
  [ICarrierApplicationStates.activated]: 'Activated',
  [ICarrierApplicationStates.application_submitted]: 'Pending Review',
  [ICarrierApplicationStates.cancelled]: 'Not Active',
  [ICarrierApplicationStates.conditional]: 'Not Active',
  [ICarrierApplicationStates.do_not_use]: 'Not Active',
  [ICarrierApplicationStates.expired_insurance]: 'Incomplete',
  [ICarrierApplicationStates.in_review]: 'In Review',
  [ICarrierApplicationStates.new]: 'New',
  [ICarrierApplicationStates.other]: 'Not Active',
  [ICarrierApplicationStates.out_of_service]: 'Not Active',
  [ICarrierApplicationStates.pending]: 'Pending Approval',
  [ICarrierApplicationStates.probation]: 'Not Active',
}

export const STATUS_TAG_STYLES: Record<ICarrierApplicationStates, TAG_STYLE> = {
  [ICarrierApplicationStates.activated]: TAG_STYLE.success,
  [ICarrierApplicationStates.application_submitted]: TAG_STYLE.warning,
  [ICarrierApplicationStates.cancelled]: TAG_STYLE.dark,
  [ICarrierApplicationStates.conditional]: TAG_STYLE.dark,
  [ICarrierApplicationStates.do_not_use]: TAG_STYLE.dark,
  [ICarrierApplicationStates.expired_insurance]: TAG_STYLE.warning,
  [ICarrierApplicationStates.in_review]: TAG_STYLE.warning,
  [ICarrierApplicationStates.new]: TAG_STYLE.warning,
  [ICarrierApplicationStates.other]: TAG_STYLE.dark,
  [ICarrierApplicationStates.out_of_service]: TAG_STYLE.dark,
  [ICarrierApplicationStates.pending]: TAG_STYLE.warning,
  [ICarrierApplicationStates.probation]: TAG_STYLE.dark,
}

export type TStatusTagLabels = typeof STATUS_TAG_LABELS
export type TStatusTagStyles = typeof STATUS_TAG_STYLES
